import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataService } from '../data-service';

@Injectable()
export class UsersDataService extends DataService {

  editUserProfile(data): Promise<any> {
    let options = { headers: new HttpHeaders().set('Content-Type', 'application/json') };
    return this.put("", "", "users/me", data, options);
  }

  getUserProfile(): Promise<any> {
    return this.get("", "", "users/me");
  }

}



// WEBPACK FOOTER //
// ./src/app/core/data-services/users/users.service.ts